import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateTheJob } from "../features/jobs/jobsSlice";
import { useNavigate, useParams } from "react-router-dom";
import { fetchJob } from "../features/job/fetchJobSlice";

const EditJobPage = () => {
  const navigate = useNavigate();
  const { jobId } = useParams();
  const { job } = useSelector((state) => state.editJob);
  // destructure object
  const { id, title, type, salary, deadline } = job || {};
  const dispatch = useDispatch();
  const [updatedTitle, setUpdatedTitle] = useState("");
  const [updatedType, setUpdatedType] = useState("");
  const [updatedSalary, setUpdatedSalary] = useState("");
  const [updatedDeadline, setUpdatedDeadline] = useState("");

  const resetFrom = () => {
    setUpdatedTitle("");
    setUpdatedType("");
    setUpdatedSalary("");
    setUpdatedDeadline("");
  };

  // fetch the job information...
  useEffect(() => {
    dispatch(fetchJob(jobId));
  }, [dispatch, jobId]);

  useEffect(() => {
    if (id) {
      setUpdatedTitle(title);
      setUpdatedType(type);
      setUpdatedSalary(salary);
      setUpdatedDeadline(deadline);
    } else {
      resetFrom();
    }
  }, [job]);

  // submit handle function...
  const submitHandlerFuc = (e) => {
    e.preventDefault();
    if (id) {
      const data = {
        title: updatedTitle,
        type: updatedType,
        salary: updatedSalary,
        deadline: updatedDeadline,
        id,
      };
      dispatch(updateTheJob({ id, data }));
      navigate("/");
    }
  };

  return (
    <>
      <h1 className="mb-10 text-center lws-section-title">Edit Job</h1>

      <div className="max-w-3xl mx-auto">
        <form className="space-y-6" onSubmit={submitHandlerFuc}>
          <div className="fieldContainer">
            <label
              htmlFor="lws-JobTitle"
              className="text-sm font-medium text-slate-300"
            >
              Job Title
            </label>
            <select
              id="lws-JobTitle"
              name="lwsJobTitle"
              required
              value={updatedTitle}
              onChange={(e) => setUpdatedTitle(e.target.value)}
            >
              <option value="" hidden>
                Select Job
              </option>
              <option value="Software Engineer">Software Engineer</option>
              <option value="Software Developer">Software Developer</option>
              <option value="Full Stack Developer">Full Stack Developer</option>
              <option value="MERN Stack Developer">MERN Stack Developer</option>
              <option value="DevOps Engineer">DevOps Engineer</option>
              <option value="QA Engineer">QA Engineer</option>
              <option value="Product Manager">Product Manager</option>
              <option value="Social Media Manager">Social Media Manager</option>
              <option value="Senior Executive">Senior Executive</option>
              <option value="Junior Executive">Junior Executive</option>
              <option value="Android App Developer">
                Android App Developer
              </option>
              <option value="IOS App Developer">IOS App Developer</option>
              <option value="Frontend Developer">Frontend Developer</option>
              <option value="Frontend Engineer">Frontend Engineer</option>
            </select>
          </div>

          <div className="fieldContainer">
            <label htmlFor="lws-JobType">Job Type</label>
            <select
              id="lws-JobType"
              name="lwsJobType"
              required
              value={updatedType}
              onChange={(e) => setUpdatedType(e.target.value)}
            >
              <option value="" hidden>
                Select Job Type
              </option>
              <option value="Full Time">Full Time</option>
              <option value="Internship">Internship</option>
              <option value="Remote">Remote</option>
            </select>
          </div>

          <div className="fieldContainer">
            <label htmlFor="lws-JobSalary">Salary</label>
            <div className="flex border rounded-md shadow-sm border-slate-600">
              <span className="input-tag">BDT</span>
              <input
                type="number"
                name="lwsJobSalary"
                id="lws-JobSalary"
                required
                className="!rounded-l-none !border-0"
                placeholder="20,00,000"
                value={updatedSalary}
                onChange={(e) => setUpdatedSalary(e.target.value)}
              />
            </div>
          </div>

          <div className="fieldContainer">
            <label htmlFor="lws-JobDeadline">Deadline</label>
            <input
              type="date"
              name="lwsJobDeadline"
              id="lws-JobDeadline"
              required
              value={updatedDeadline}
              onChange={(e) => setUpdatedDeadline(e.target.value)}
            />
          </div>

          <div className="text-right">
            <button
              type="submit"
              id="lws-submit"
              disabled={!id}
              className={`${
                id ? "cursor-pointer" : "cursor-not-allowed"
              } btn btn-primary w-fit`}
            >
              Update
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default EditJobPage;
